import { jsx } from 'react/jsx-runtime';
import { useState, useCallback, useEffect, useId, useMemo } from 'react';
import { useAccordionPanelGroupContext } from '../AccordionPanel.Group/AccordionPanelGroup.Context/index.es.js';
import { AccordionPanelContext } from './context.es.js';

/**
 * AccordionPanel Provider.
 */ const AccordionPanelProvider = (state)=>{
    const { open, children, size, onCard, ...rest } = state;
    // Control open state in shared provider so all subcomponents can adjust accordingly
    const [isOpen, setIsOpen] = useState(open);
    // If accordion group is used, get the group's values to override individual accordion config
    const groupValues = useAccordionPanelGroupContext();
    const handleHeaderClick = useCallback(()=>{
        setIsOpen((open)=>!open);
    }, []);
    // Allow open state to be controlled from the outside and update internal isOpen state, whenever open changes
    useEffect(()=>{
        if (open !== undefined) setIsOpen(open);
    }, [
        open
    ]);
    // Define id to bind Header and Content with `aria-controls`
    const ariaId = useId();
    const values = useMemo(()=>{
        return {
            ariaId,
            open: isOpen,
            size: groupValues?.size ?? size,
            onCard: groupValues?.onCard ?? onCard,
            ...rest
        };
    }, [
        groupValues?.onCard,
        groupValues?.size,
        ariaId,
        isOpen,
        onCard,
        rest,
        size
    ]);
    const actions = useMemo(()=>({
            handleHeaderClick
        }), [
        handleHeaderClick
    ]);
    return jsx(AccordionPanelContext.Provider, {
        value: [
            values,
            actions
        ],
        children: children
    });
};

export { AccordionPanelProvider };
//# sourceMappingURL=provider.es.js.map
